require('../login/loginController');
require('../fhApp/cdnUrl/cdnUrl');

"use strict";

angular.module('app.mobileLogin', [
  'app.login.loginController',
  'app.cdnUrl'
])
  .config([
    '$stateProvider', 'PRODUCT',
    function ($stateProvider, product) {
      
      let logTemplate = 'components/mobileLogin/mobileLoginView.html';
      if (product.Code != 'htv') {
        logTemplate = 'assets/templates/' + product.Code + '/mobileLogin/mobileLoginView.html';
      }

      $stateProvider.state('app.mobileLogin', {
        url: '/mobile-login',
        templateUrl: logTemplate,
        controller: 'app.login.loginController',
        params: {
          error: null,
          errorType: null,
          redirect: null,
          redirectParams: null,
          autoLogin: false,
          login_name: null,
          password: null
        },
        title: 'Mobile Sign In',
        noSidebar: true,
        noTitleBar: true
      });
    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/mobileLogin/mobileLogin.js